export default __webpack_public_path__ + "static/media/104.f6ce1df5.jpg";